goog.provide("shadow.js.shim.module$src$svg$editor$objects$link_svg");
goog.provide("module$shadow_js_shim_module$src$svg$editor$objects$link_svg");
shadow.js.shim.module$src$svg$editor$objects$link_svg = shadow.js.nativeProvides["src/svg/editor/objects/link.svg"] = shadow$bridge("src/svg/editor/objects/link.svg");
module$shadow_js_shim_module$src$svg$editor$objects$link_svg.default = shadow.js.shim.module$src$svg$editor$objects$link_svg;
